require('angular')
require('angular-route')
require('angular-ui-map')

require('../../core/translation/translation-module')
require('../components/flash/flash-module')
require('../components/error-handler/error-handler-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/form/form-module')
require('../components/animate/animate-module')
require('../components/account/account-module')
require('../components/auth/auth-module')
require('../group-event/group-event-module')


#load Templates
require('./header.jade')
require('./members.jade')
require('./events.jade')

# Load Css

# Load Controller
GroupInfoHeaderCtrl = require('./group-info-header-controller')
GroupInfoMembersCtrl = require('./group-info-members-controller')
GroupInfoEventsCtrl = require('./group-info-events-controller')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-common-wrapper'
  'gnp-remote-api'
  'gnp-form'
  'gnp-flash'
  'gnp-animate'
  'gnp-error-handler'
  'gnp-app-group-event'
]

angular.module 'gnp-app-group-info', modules
  .config ['$routeProvider', '$translateProvider', ($routeProvider, $translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'GroupInfoHeaderCtrl', GroupInfoHeaderCtrl
  .controller 'GroupInfoMembersCtrl', GroupInfoMembersCtrl
  .controller 'GroupInfoEventsCtrl', GroupInfoEventsCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-info/group-information-module.coffee